export const API_ROUTE = {
  RECUPERATION_GESTIONS_PILOTEES: '/versement/gestion-pilotee/recuperation-gps',
  NOUVELLE_OPERATION: '/versement/gestion-pilotee/nouvelle-operation',
  FAIRE_VERSEMENT: '/versement/gestion-pilotee/faire-versement',

  SAUVEGARDER_FICHIERS: '/versement/gestion-pilotee/sauvegarde-fichier',
  VALIDATION_UNIVERSIGN: '/versement/gestion-pilotee/validation-justificatifs-universign',
  VALIDATION_COORDONNEES: '/versement/gestion-pilotee/validation-coordonnees',
  VALIDATION_CODE: '/versement/gestion-pilotee/validation-token',
  FAIRE_VERSEMENT_SUCCES: '/standby-fin-tunnel/gestion-pilotee',
};
